import React from "react";

import {
  Button,
  Stack,
  Typography,
} from "@mui/material";

import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";

const getAttachmentName = (value) => {
  if (typeof value !== "string") {
    return "Attachment";
  }

  const withoutQuery =
    value.split("?")[0];

  const filename =
    withoutQuery.substring(
      withoutQuery.lastIndexOf("/") + 1,
    );

  if (!filename) {
    return "Attachment";
  }

  try {
    return decodeURIComponent(filename);
  } catch (error) {
    return filename;
  }
};

const ConsultationDocuments = ({
  attachments = [],
}) => {
  const documents =
    Array.isArray(attachments)
      ? attachments.filter(
          (item) =>
            typeof item === "string" &&
            item.trim(),
        )
      : [];

  if (!documents.length) {
    return (
      <Typography
        variant="body2"
        color="text.secondary"
      >
        No reports or documents are available yet.
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      {documents.map((url) => (
        <Button
          key={url}
          variant="outlined"
          startIcon={
            <FilePresentOutlinedIcon />
          }
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
          }}
        >
          {getAttachmentName(url)}
        </Button>
      ))}
    </Stack>
  );
};

export default ConsultationDocuments;